import { z } from 'zod'
import type { OrganizationMetricAssignment } from '#/domain/catalog/OrganizationMetricAssignment'

export const OrganizationMetricAssignmentDtoSchema = z
  .object({
    Id: z.string(),
    MetricId: z.string().nullable().optional().default(null),
    OrganizationId: z.string().nullable().optional().default(null),
    LayerId: z.string().nullable().optional().default(null),
    RiskType: z.string().nullable().optional().default(null),
    ApplicationId: z.string(),
    DisplayOrder: z.number().nullable().optional().default(null),
    MinLevel: z.number().nullable().optional().default(null),
    MaxLevel: z.number().nullable().optional().default(null),
  })
  .transform((raw): OrganizationMetricAssignment => ({
    Id: raw.Id,
    MetricId: raw.MetricId,
    OrganizationId: raw.OrganizationId,
    LayerId: raw.LayerId,
    RiskType: raw.RiskType,
    ApplicationId: raw.ApplicationId,
    DisplayOrder: raw.DisplayOrder,
    MinLevel: raw.MinLevel,
    MaxLevel: raw.MaxLevel,
  }))

export type OrganizationMetricAssignmentResponseDto = z.input<
  typeof OrganizationMetricAssignmentDtoSchema
>

export function toDomain(
  raw: OrganizationMetricAssignmentResponseDto,
): OrganizationMetricAssignment {
  return OrganizationMetricAssignmentDtoSchema.parse(raw)
}

export function toDomainList(
  raw: OrganizationMetricAssignmentResponseDto[],
): OrganizationMetricAssignment[] {
  return raw.map(toDomain)
}
